import { render, staticRenderFns } from "./unitPromotionList.vue?vue&type=template&id=d385014a&scoped=true&"
import script from "./unitPromotionList.vue?vue&type=script&lang=js&"
export * from "./unitPromotionList.vue?vue&type=script&lang=js&"
import style0 from "./unitPromotionList.vue?vue&type=style&index=0&id=d385014a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d385014a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
